import { render } from "./PaymentScreen.vue?vue&type=template&id=5420598c&scoped=true"
import script from "./PaymentScreen.vue?vue&type=script&lang=js"
export * from "./PaymentScreen.vue?vue&type=script&lang=js"

import "./PaymentScreen.vue?vue&type=style&index=0&id=5420598c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5420598c"]])

export default __exports__